import React from 'react';

import ItemsProviderSynchronizer from '@common/react/components/Core/AdvancedItemsProvider/ItemsProviderSynchronizer';

import { AppointmentStatus } from '@app/objects/Appointment';
import { StatusesProvider } from '@app/components/UI/AppointmentStatus/StatusesProvider';

export const StatusesSynchronizer: React.FC = () => {
	return <StatusesProvider>
		<ItemsProviderSynchronizer<AppointmentStatus>
			objectType="AppointmentStatusRedux"
			getItemsFromInit={(notification) => notification.data.appointmentStatuses}
		/>
	</StatusesProvider>;
};
